import { useNavigate } from 'react-router-dom';
import { SignupLayout } from './Layout.tsx';
import { useSignup } from './state.ts';

/**
 * Screen 6 — "All set" handoff back to the canvas.
 *
 * Per spec §11.3.3 we leave the parent with ONE practical tip: that the
 * verification email is on its way and the canvas keeps working in the
 * meantime. The cross-device sync paragraph is the gentle nudge to check
 * email on a different device if needed.
 */
export function Step6Done(): JSX.Element {
  const navigate = useNavigate();
  const { child, reset } = useSignup();

  const onStart = (): void => {
    reset();
    navigate('/');
  };

  return (
    <SignupLayout
      step={6}
      title={`All set${child.displayName ? `, ${child.displayName}!` : '!'} 🎉`}
      subtitle="One more thing: we sent a confirmation email. Click the link there in the next 24 hours so we can keep your art saved."
    >
      <div className="rounded-2xl bg-amber-50 p-4 text-sm text-slate-700">
        <p className="font-medium">Pro tip</p>
        <p className="mt-1">
          The link in the email works on any device — phone, laptop, the school&rsquo;s tablet — so
          check it wherever&rsquo;s easiest.
        </p>
      </div>

      <button
        type="button"
        onClick={onStart}
        className="mt-6 w-full rounded-2xl bg-amber-500 px-6 py-4 text-lg font-semibold text-white shadow transition active:scale-95 hover:bg-amber-600"
      >
        Start making things
      </button>
    </SignupLayout>
  );
}
